import { useCallback, useEffect } from 'react'
import CFDToolbar from 'views/CustomerFacingDisplay/components/CFDToolbar'
import { CFDHwAgentSettingPage } from './CFDHwAgentSettingPage'
import { Box } from '@mui/material'
import { Route, Switch } from 'react-router-dom'
import CFDCodeConnectorPage from 'pages/CustomerFacingDisplayPage/CFDCodeConnectorPage'
import CFDMainPage from 'pages/CustomerFacingDisplayPage/CFDMainPage'
import { useCFDContext } from './context/useCFDContext'
import Loading from 'components/Loading/Loading'
import {
    HWAGENT_STORE,
    CLIENT_STORE,
    POS_CFD_HWAGENT,
} from 'views/CustomerFacingDisplay/utils/localStorageKey'
import useValidateConnection from './hook/useValidateConnection'
export const CFDROUTE = {
    HOME: '/cfd',
    HW_SETTING: '/cfd/hw-agent-settup',
    CONNECT_CODE: '/cfd/connection',
}

const CFDLayout = () => {
    const {
        hwAgentUrl,
        handleConnectToHardwareAgent,
        loadedLocalSetting,
        isLoadedLocalSetting,
    } = useCFDContext()
    const { isTokenValid } = useValidateConnection(false)

    const LoadSetting = useCallback(async () => {
        let url = localStorage.getItem(HWAGENT_STORE)
        if (!url) {
            if (await isTokenValid()) {
                url = localStorage.getItem(POS_CFD_HWAGENT)
            } else localStorage.removeItem(POS_CFD_HWAGENT)
        }
        const client = localStorage.getItem(CLIENT_STORE)

        loadedLocalSetting({ clientID: client ?? '', hwAgentUrl: url ?? '' })
    }, [isTokenValid, loadedLocalSetting])

    useEffect(() => {
        if (isLoadedLocalSetting) return
        LoadSetting()
    }, [LoadSetting, isLoadedLocalSetting])

    useEffect(() => {
        if (hwAgentUrl) handleConnectToHardwareAgent()
    }, [handleConnectToHardwareAgent, hwAgentUrl])

    if (!isLoadedLocalSetting)
        return (
            <Box>
                <Loading />
            </Box>
        )

    return (
        <div>
            <Box>
                <CFDToolbar />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                    }}
                >
                    <Switch>
                        <Route exact path={CFDROUTE.HOME}>
                            <CFDMainPage />
                        </Route>

                        <Route path={CFDROUTE.HW_SETTING}>
                            <CFDHwAgentSettingPage />
                        </Route>
                        <Route path={CFDROUTE.CONNECT_CODE}>
                            <CFDCodeConnectorPage />
                        </Route>
                    </Switch>
                </Box>
            </Box>
        </div>
    )
}

export default CFDLayout
